import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { WebSocketService } from '@core/services'
import { ClassicService, RushMainService } from '@rush-shared/services'
import { PlayerService } from '@shared/services'
import { distinct, filter } from 'rxjs'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-pot',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './pot.component.html',
  styleUrl: './pot.component.sass',
})
export class PotComponent {
  private activeTableId: string
  faRightFromBracket = faRightFromBracket

  onSeat = false

  get showGameComponent() {
    return this._classicService.showGameComponent || this.onSeat
  }

  constructor(
    private _webSocketService: WebSocketService,
    public _playerService: PlayerService,
    public _classicService: ClassicService,
    private _rushMainService: RushMainService,
  ) {
    this._classicService.activeTable.potBonus

    this._classicService.activeTable$
      .pipe(filter((i) => i.id !== this.activeTableId))
      .subscribe((i) => {
        this._webSocketService.removePotListener(this.activeTableId)

        this._webSocketService.listenToPotBonusUpdate(i.id, (pot) => {
          this._playerService.potBonus = pot.amount
          this._classicService.setTablePot(pot.amount)
        })

        this.activeTableId = i.id
      })
  }

  back() {
    this._classicService.resetActiveDelear()
    this._playerService.clearCurrentSeat()
  }
}
